import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
import FormItem from "forms/fields/FormItem";
import type { FormControlType } from "types/formType";
import type { IFormInputs } from "types/uiSchema";
import { MultiSelect as UiMultiSelect } from "ui/MultiSelect/MultiSelect";
import { FormField } from "uiShadcn/form";
interface MultiSelectProps {
  control: FormControlType;
  uiData: IFormInputs;
}
export default function MultiSelect(t0) {
  const $ = _c(13);
  const {
    control,
    uiData
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const name = uiData["x-json-schema-reference-property"];
  let t1;
  if ($[0] !== uiData.required) {
    t1 = uiData?.required?.includes("true");
    $[0] = uiData.required;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isRequired = t1;
  let t2;
  if ($[2] !== uiData) {
    t2 = uiData["x-dictionary"] ?? [];
    $[2] = uiData;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const dictionary = t2;
  if (!name || dictionary?.length === 0) {
    return null;
  }
  let t3;
  if ($[4] !== dictionary || $[5] !== formatMessage || $[6] !== isRequired || $[7] !== uiData.description) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormItem label={uiData.description} required={isRequired}><UiMultiSelect options={dictionary} onValueChange={field.onChange} defaultValue={field.value} placeholder={formatMessage({
          id: "choose"
        })} maxCount={3} dataTestId={field.name} required={isRequired} ref={field.ref} /></FormItem>;
    };
    $[4] = dictionary;
    $[5] = formatMessage;
    $[6] = isRequired;
    $[7] = uiData.description;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== control || $[10] !== name || $[11] !== t3) {
    t4 = <FormField control={control} name={name} render={t3} />;
    $[9] = control;
    $[10] = name;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}